import { connect, Dispatch } from 'react-redux';
import { AppState } from '../../../..';
import { FileRemoveComponent, FileRemoveProps } from '@common/components/file-upload/_components/file-remove.component';
import { VendorViewModel } from '@models/Vendor';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState): Partial<FileRemoveProps> {
  return {};
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: { saveCallback: Function }
): Partial<FileRemoveProps> {
  return {
    onSaveClick: (fileId: number, vendor: VendorViewModel) => {
      ownProps.saveCallback(fileId, vendor);
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const FileRemove = connect(
  mapStateToProps,
  mapDispatchToProps
)(FileRemoveComponent);



// WEBPACK FOOTER //
// ./src/common/components/file-upload/_components/file-remove.container.ts